module.exports = __webpack_public_path__ + "img/8b.581acb0d.jpg";